Vue.component('ack-range-input', {
  delimiters: ['${', '}$'], // (i) We set up custom delimiters to avoid conflict with liquid interpolations.
  template: '#ack-range-input',
  props:{
    label: {
      type: String,
      default: ''
    },
    labelMin: {
      type: String,
      default: 'Min'
    },
    labelMax: {
      type: String,
      default: 'Max'
    },
    absoluteMin: {
      type: Number,
      required: true
    },
    absoluteMax: {
      type: Number,
      required: true
    },
    initialMinValue: {
      type: Number,
      required: true
    },
    initialMaxValue: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      minValue: null,
      maxValue: null,
      
    }
  },
  computed: {
    //...Vuex.mapGetters('navBar', ['switchMobileDropdowns']),
    returnedValue(){
      return {min: this.minValue, max: this.maxValue}
    },
    isMobile(){
      return this.$parent.isMobile
    },
    rangeStart(){
      return ((this.minValue) / this.absoluteMax) * 100
    },
    rangeEnd(){
      return (((this.maxValue) / this.absoluteMax) * 100) - (((this.minValue) / this.absoluteMax) * 100)
    }
  },
  created() {
    appLog.log('ack-range-input created', LOG_TYPE.debug)
    
    this.maxValue = this.initialMaxValue
    setTimeout(()=> {
      appLog.log(`ack-range-input minValue = initialMinValue =${this.initialMinValue}`, LOG_TYPE.debug)
      this.minValue = this.initialMinValue
      appLog.log(`ack-range-input minValue = ${this.minValue} = initialMinValue =${this.initialMinValue}`, LOG_TYPE.debug)
      appLog.log(`ack-range-input maxValue = ${this.maxValue} = initialMaxValue =${this.initialMaxValue}`, LOG_TYPE.debug)
    }, 100)
    
    
    
  },
  mounted() {
    appLog.log('ack-range-input mounted', LOG_TYPE.debug)
    
    // this.maxValue = this.initialMaxValue
    // this.minValue = this.initialMinValue
    
    
  },
  methods: {
    //...Vuex.mapActions(['sayHi', 'someAction']),
    //...Vuex.mapActions('navBar', ['sayHi', 'closeAllMobileDropdowns'])   

  },
  beforeDestroy() {
    
  },
  watch: {
    isMobile: {
      handler() {
        
        
      },
      deep: false
    },
    minValue: {
      handler(newVal, oldVal) {
        if ((this.maxValue != null) && (newVal > this.maxValue)) {
          this.minValue = oldVal
        } else {
          
          this.$emit('input', this.returnedValue)
        }
      },
      deep: false
    },
    // minValue(newVal, oldVal) {
    //   if (newVal > this.maxValue) {
    //     this.minValue = oldVal
    //   }
    // },
    maxValue: {
      handler(newVal, oldVal) {
        if ((this.minValue != null) && (newVal < this.minValue)) {
          this.maxValue = oldVal
        } else {
          this.$emit('input', this.returnedValue)
        }
      },
      deep: false
    },
    // maxValue(newVal, oldVal) {
    //   if (newVal < this.minValue) {
    //     this.maxValue = oldVal
    //   }
    // }
  }
})